import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { CartSettingsContext } from './context.js';

const defaultSettings = {
    allowBackOrder: true,
    hideStockAndDeliveryOnLineItem: false,
    multiDiscountType: false,
    showSubTotal: true,
    showTotalDiscount: true,
    showCartDiscountDescriptions: true,
    isDiscountCodeEnabled: false
};
const CartSettingsProvider = ({ children , settings ,  })=>{
    const [cartId, setCartId] = React.useState(settings.cartId);
    const [cartHash, setCartHash] = React.useState(settings.cartHash);
    const setContext = React.useCallback(({ cartHash: newCartHash , cartId: newCartId  })=>{
        newCartId && setCartId(newCartId);
        newCartHash && setCartHash(newCartHash);
    }, []);
    const value = React.useMemo(()=>swcHelpers.objectSpread({}, defaultSettings, settings, {
            cartHash,
            cartId,
            setContext
        })
    , [
        cartHash,
        cartId,
        setContext,
        settings
    ]);
    return /*#__PURE__*/ React.createElement(CartSettingsContext.Provider, {
        value: value
    }, children);
};

export { CartSettingsProvider, defaultSettings };
//# sourceMappingURL=provider.js.map
